export const environment = {
  production: false,
  hmr: true,
  serverUrl: 'https://zyno.procuar.api.elitetraveltech.in',                                   
  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  //  serverUrl: 'http://192.168.20.165:8000', //ashutosh
  // serverUrl: 'https://procurementapi.elitetraveltech.in',                                   
  //  webserver: 'ws://192.168.20.165:8000',
  // serverUrl: 'http://192.168.20.129:8000',//shashi
  // serverUrl: 'http://192.168.20.107:8000', //yash 
  // serverUrl: 'http://localhost:8000', //vishal
  defaultLanguage: 'Label',
  supportedLanguages: ['Label', 'TMSA'],
};
